import logService from '../wss/logService3';
import CacheBase2 from './CacheBase2';

const _name = 'QuotaCache';

class QuotaCache extends CacheBase2 {
    /**
     * Replaces the full quota list in cache.
     * @param {Array} items
     */
    setItems = (items) => {
        this.setCache(items);
    };

    /**
     * Inserts or updates a quota item by name.
     * @param {Object} item - UserQuotaDto
     */
    upsert = (item) => {
        this._check();
        const idx = this._items.findIndex((x) => x.name === item.name);
        if (idx === -1) {
            this._items.push(item);
        } else {
            this._items[idx] = { ...this._items[idx], ...item };
        }
    };

    /**
     * Removes a quota item by name.
     * @param {string} name - Journal name
     */
    removeByName = (name) => {
        this._items = this._items.filter((x) => x.name !== name);
    };

    getItems = () => {
        return this.getAll();
    };
}

const quotaCache = new QuotaCache();
export default quotaCache;
